const assemblyConfig = Object.assign(
    {},
    ...process.env.ASSEMBLIES.split(',').map(
        (fileName) => require(`./assembly/${fileName}.js`) // eslint-disable-line import/no-dynamic-require,global-require
    )
)

module.exports = assemblyConfig
